import { Component } from 'react';
import PropTypes from 'prop-types';
import TimeMissingFiatV2 from '../../../TimeMissingFiatV2';

export default class Card extends Component {
  compareTitles(title, subtitle) {
    const fcaApiBrand = document.querySelector("meta[name='fca_api_brand']");
    const brand = fcaApiBrand ? fcaApiBrand.content : '';

    return title === subtitle ? brand : subtitle;
  }

  imageAlt() {
    const { title, subtitle } = this.props;

    return `Imagem do ${title} ${this.compareTitles(title, subtitle)}`;
  }

  formatExpiredAt(date) {
    return window.railsDateToChronometer(date);
  }

  offerFeatured(featured) {
    const { offerType } = this.props;

    const inCashOrEntryWithInstallments = 2;
    const customTitleOffer = 5;

    if (offerType === inCashOrEntryWithInstallments) {
      const pattern = /R\$\s\d{1,3}(?:\.\d{3})*(?:,\d{2})?/;
      const value = featured.match(pattern);
      const valueMessage = featured.split(value);

      return (
        <div className="card__trigger-value-in-cash">
          {valueMessage[0]} <span>{value}</span> {valueMessage[1]}
        </div>
      );
    }

    if (offerType === customTitleOffer) {
      return <div style={{ whiteSpace: 'wrap' }}>{featured}</div>;
    }

    return featured;
  }

  render() {
    const {
      slug,
      image,
      title,
      subtitle,
      seal_list,
      secondary_call,
      main_call,
      featured,
      description,
      badge,
      part_link,
      expiredAt,
    } = this.props;

    const link = `${part_link}/${slug}`;

    return (
      <a className="offers-fca-card__link" href={link}>
        <div className="card offers-fca-card">
          {!!expiredAt && (
            <TimeMissingFiatV2 date={this.formatExpiredAt(expiredAt)} />
          )}

          <div className="card__header">
            <img
              className="offers-fca-card__image"
              src={image}
              alt={this.imageAlt()}
              width="223"
              height="128"
            />
          </div>

          <div className="card__content offers-fca-card__content">
            <div>
              <div className="card__title offer-card__title">{title}</div>
              <div className="card__subtitle">
                {this.compareTitles(title, subtitle)}
              </div>
            </div>

            {!!badge && <div className="offers-fca-card__badge">{badge}</div>}

            <div>
              <ul className="card__list list offers-fca-card__list">
                {seal_list.slice(0, 3).map(item => (
                  <li className="offers-fca-card__list-item">{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="card__footer">
            <div className="card__box-offer offers-fca-card__prices">
              {secondary_call && (
                <p className="card__trigger-starting-price">{secondary_call}</p>
              )}
              {main_call && (
                <p className="card__title footer-card__title">{main_call}</p>
              )}
              {!!featured && (
                <div className="card__trigger-value">
                  {this.offerFeatured(featured)}
                </div>
              )}
              {!!description && (
                <div className="card__trigger-description">{description}</div>
              )}
            </div>
            <button
              type="button"
              className="btn button button--block button--large button--primary card__cta"
            >
              <div className="card__cta-background" />
              <div className="card__cta-text">Eu quero</div>
            </button>
          </div>
        </div>
      </a>
    );
  }
}

Card.defaultProps = {
  title: '',
  subtitle: '',
  image: '',
  part_link: '',
  slug: '',
  seal_list: [],
  badge: '',
  expiredAt: '',
  categorySlug: '',
};

Card.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  part_link: PropTypes.string,
  slug: PropTypes.string,
  seal_list: PropTypes.arrayOf(PropTypes.string),
  offer: PropTypes.shape({
    secondary_call: PropTypes.string,
    main_call: PropTypes.string,
    featured: PropTypes.string,
    description: PropTypes.string,
  }),
  badge: PropTypes.string,
  expiredAt: PropTypes.string,
  offerType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  secondary_call: PropTypes.string,
  main_call: PropTypes.string,
  featured: PropTypes.string,
  description: PropTypes.string,
  categorySlug: PropTypes.string,
};
